import { ENV } from "@config/env";
import { constructQueryString } from "@utils/util";
import LOCAL_STORAGE from "@utils/localStorage";
import PATHS from "@utils/paths";

export const baseUrl = ENV.API_HOST;
// export const baseUrl = "https://api.inorain.tv/";

export const request = async (
  method = "GET",
  url,
  queryParams = {},
  data = null,
) => {
  url = baseUrl + url;

  const queryString = constructQueryString(queryParams);
  if (queryString) {
    url += "?" + queryString;
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          const response = JSON.parse(xhr.responseText);
          if (response.code === 403) {
            LOCAL_STORAGE.LAST_CHANNEL_ID.REMOVE();
            LOCAL_STORAGE.TOKEN.REMOVE();
            reject(response);
          } else {
            resolve(xhr.responseText);
          }
        } catch (error) {
          resolve(xhr.responseText);
        }
      }
    };
    xhr.onerror = function () {
      reject(new Error("Network request failed"));
    };
    xhr.open(method, url, true);
    if (method.toUpperCase() === "POST" || method.toUpperCase() === "PUT") {
      if (LOCAL_STORAGE.TOKEN.GET() && LOCAL_STORAGE.TOKEN.GET() != "undefined")
        xhr.setRequestHeader("authorization", LOCAL_STORAGE.TOKEN.GET());

      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify(data));
    } else {
      if (LOCAL_STORAGE.TOKEN.GET() && LOCAL_STORAGE.TOKEN.GET() != "undefined")
        xhr.setRequestHeader("authorization", LOCAL_STORAGE.TOKEN.GET());
      xhr.send();
    }
  });
};
